import { render } from "./IncomeListPage.vue?vue&type=template&id=3bdef3ba&ts=true"
import script from "./IncomeListPage.vue?vue&type=script&lang=ts"
export * from "./IncomeListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__